import React, { useState } from 'react';
import { bool, func } from 'prop-types';
import { useForm } from 'react-hook-form';
import { AUIModal } from '@ancert/aui-modal';
import AUIInputTextAreaField from '@ancert/aui-input-textarea-field';
import { useSession } from '../../context/session.context';
import { defaultValues, resolver } from './form';
import { ROL } from '../../lib/role.enum';
import { MAX_TEXT_AREA } from '../../config';

const ModalNewComentario = ({ show, onClose, onAccept }) => {
  const [responseRequired, setResponseRequired] = useState(false);
  const { getUser } = useSession();
  const { role } = getUser();
  const { control, formState, handleSubmit, reset } = useForm({
    defaultValues,
    resolver,
    mode: 'onSubmit',
  });
  const closeModal = () => {
    reset(defaultValues);
    setResponseRequired(false);
    onClose();
  };

  const onSubmit = (data) => {
    onAccept({ ...data, responseRequired });
    closeModal();
  };

  const sideCheckbox = {
    id: 'checkbox',
    defaultChecked: false,
    label: 'Se requiere una respuesta en un plazo máximo de 5 días.',
    onChange: () => setResponseRequired(!responseRequired),
  };

  const buttons = [
    {
      id: 'primary',
      mode: 'primary',
      label: 'Añadir',
      onClick: handleSubmit(onSubmit),
    },
    {
      id: 'tertiary',
      mode: 'tertiary',
      label: 'Cancelar',
      onClick: closeModal,
      disabled: false,
    },
  ];

  return (
    <AUIModal
      size="lg"
      title="Agregar comentario"
      show={show}
      actionButtons={buttons}
      autoHeight
      sideCheckbox={ROL.ADMINISTRADOR === role && sideCheckbox}
      onClose={closeModal}
    >
      <form autoComplete="off">
        <div className="o-grid">
          <div className="o-grid__row">
            <div className="o-grid__col-12">
              <AUIInputTextAreaField
                id="descripcion"
                name="description"
                label="Escribir un comentario (máx. 150 caracteres)"
                controlRef={control}
                errors={formState.errors}
                required
                maxLength={MAX_TEXT_AREA}
              />
            </div>
          </div>
        </div>
      </form>
    </AUIModal>
  );
};
ModalNewComentario.propTypes = {
  show: bool,
  onAccept: func,
  onClose: func,
};
ModalNewComentario.defaultProps = {
  show: false,
  onAccept: null,
  onClose: null,
};

export default ModalNewComentario;
